import { Checkbox, Dropdown, Menu, TablePaginationConfig } from 'antd'
import { Key } from 'antd/es/table/interface'
import { ColumnType } from 'antd/lib/table'

import Button from '../general/Button'

export type TableColumns = (ColumnType<any> & { isStatic?: boolean })[]

type TableProps = {
  columns: TableColumns
  onSelectedColumnsChange?: (selectedColumns: Key[]) => void
  selectedColumns: Key[]
}

export default function TableFilter(props: TableProps) {
  const { columns, selectedColumns, onSelectedColumnsChange } = props

  const menu = (
    <Menu>
      <Checkbox.Group defaultValue={selectedColumns} onChange={onSelectedColumnsChange}>
        <div>
          {columns
            .filter((column) => !column.isStatic)
            .map((column: any) => (
              <div className="flex p-4">
                <Checkbox className="mr-4" value={column.key} /> {column.title}
              </div>
            ))}
        </div>
      </Checkbox.Group>
    </Menu>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
      <Button type="default" icon="fa fa-filter">
        Filter columns
      </Button>
    </Dropdown>
  )
}
